// this service should accept any get link
// have a set of core methods
// that returns a customer location object
// then in the future, if we need to
import { getCookie } from "../utils/getCookie";
import { setCookie } from "../utils/setCookie";

const geoLocationService = {
  currentCountryCode: null,

  fetchAndSaveUserCountryIsoCode: async function () {
    // Saved Locally ?
    if (geoLocationService.currentCountryCode) {
      return geoLocationService.currentCountryCode
    }

    // Saved in cookie ?
    const userCountryCode = getCookie('userCountryCode')
    if (userCountryCode) {
      geoLocationService.currentCountryCode = userCountryCode
      return geoLocationService.currentCountryCode
    }

    // No local or cookie? Get from API.
    const countryCodeFromApi = await geoLocationService.fetchUserCountryIsoCode()
    
    // Set cookie and locally
    geoLocationService.currentCountryCode = countryCodeFromApi
    const days = 7;
    setCookie('userCountryCode', geoLocationService.currentCountryCode, days);

    // Return
    return geoLocationService.currentCountryCode
  },

  fetchUserCountryIsoCode: function() {
    return new Promise((resolve, reject) => {
      try {
        geoLocationService.maxmindIsLoaded().then(() => {
          const onSuccess = (geoipResponse) => {
            const isoCode = geoLocationService.getCountryIsoCode(geoipResponse)
            resolve(isoCode)
          }
          const onError = (error) => console.error('geoLocationService.fetchUserCountryIsoCode() >>> onError', error)
          geoip2.country(onSuccess, onError)
        })
      } catch (error) {
        reject(error)
      }
    })
  },

  getCountryIsoCode: async (dataObject) => {
    const result = await geoLocationService.findNestedProperty('iso_code', dataObject)
    return result
  },

  findNestedProperty: (propertyToFind, object) => {
    return new Promise((resolve) => {
      const recursiveLookup = (propertyToFind, object) => {
        for (const key in object) {
          if (Object.hasOwnProperty.call(object, key)) {
            if (key === propertyToFind) {
              const value = object[key];
              resolve(value)
            } else {
              if (typeof object[key] == "object" && object[key] !== null) {
                recursiveLookup(propertyToFind, object[key])
              }
            }
          }
        }
      }
      recursiveLookup(propertyToFind, object)
    })
  },

  maxmindIsLoaded: function () {
    return new Promise((resolve) => {
      let maxmindLoadedChecker;
      function checker() {
        if (typeof geoip2 !== 'undefined') {
          window.cancelAnimationFrame(maxmindLoadedChecker);
          maxmindLoadedChecker = undefined;
          resolve();
        } else {
          maxmindLoadedChecker = window.requestAnimationFrame(() => {
            checker();
          });
        }
      }

      checker();
    });
  },
}

export { geoLocationService };